import type { UnifiedMarketItem } from "@shared/schema";

export type PropertyMarketFilters = Record<string, string | string[]>;

export function shouldShowPropertySubFilter(
  filterId: string,
  filters: PropertyMarketFilters,
) {
  const transaction = filters["property-transaction"];
  const listingType = filters["property-listing-type"];

  if (filterId === "property-listing-type") {
    return transaction === "sale" || transaction === "rent";
  }
  if (filterId === "property-room-type") {
    return transaction === "rent" && listingType === "room";
  }
  if (filterId === "property-price-period") {
    return transaction === "rent";
  }
  return true;
}

const SALE_LISTING_TYPES = new Set([
  "house",
  "apartment",
  "townhouse",
  "unit",
  "villa",
  "studio",
  "land",
  "commercial",
]);

export function isPropertyFilterOptionAvailable(
  filterId: string,
  optionId: string,
  filters: PropertyMarketFilters,
) {
  if (filterId !== "property-listing-type") return true;
  return filters["property-transaction"] !== "sale" || SALE_LISTING_TYPES.has(optionId);
}

export function matchesPropertyMarketFilters(
  item: UnifiedMarketItem,
  filters: PropertyMarketFilters,
) {
  const transaction = filters["property-transaction"];
  const listingType = filters["property-listing-type"];
  const roomType = filters["property-room-type"];
  const pricePeriod = filters["property-price-period"];

  if (typeof transaction === "string" && transaction && item.propertyType !== transaction) return false;
  if (typeof listingType === "string" && listingType && item.listingType !== listingType) return false;
  if (typeof roomType === "string" && roomType && item.roomType !== roomType) return false;
  if (typeof pricePeriod === "string" && pricePeriod && item.pricePeriod !== pricePeriod) return false;
  return true;
}
